import Vue from "vue";
import {
  Button,
  Checkbox,
  CheckboxGroup,
  Toast,
  Radio,
  RadioGroup,
} from "vant";

Vue.use(Button);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Toast);

console.log("script start");

setTimeout(() => {
  console.log("setTimeout1");
}, 1 * 2000);

Promise.resolve()
  .then(function () {
    console.log("promise1");
  })
  .then(function () {
    console.log("promise2");
  });

async function foo() {
  await bar();
  console.log("async1 end");
}
foo();

function bar() {
  console.log("async2 end");
}

console.log("script end");
